import moment from "moment/min/moment-with-locales";
import { getApiV1Events, type EventItem } from "../client";
import type { eventType } from "../hardcoded/events";
import { apiData } from "./api";

export async function fetchEvents(): Promise<EventItem[]> {
    try {
        return await apiData(getApiV1Events());
    } catch (e) {
        console.error("Failed to fetch events.", e);
        return [];
    }
}

export function toEventType(item: EventItem, localTime = false): eventType {
    let from = moment.utc(item.from);
    let to = moment.utc(item.to);
    if (localTime && !item.isFullDay) {
        from = from.local();
        to = to.local();
    }
    return {
        from,
        to,
        title: item.title ?? {},
        description: item.description ?? {},
        location: item.location ?? "",
        link: item.link ?? "",
        isFullDay: item.isFullDay,
    };
}

export function toEventTypes(items: EventItem[], localTime = false): eventType[] {
    const now = moment();
    return items.map((item) => toEventType(item, localTime)).filter((event) => event.from.isAfter(now));
}
